import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ead53c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "cd-list__title" };
const _hoisted_2 = { class: "cd-list__description" };
const _hoisted_3 = {
    key: 0,
    class: "cd-list__slots"
};
import { reactive, onMounted } from 'vue';
import CustomerDistributionSlot from '@/features/CustomerDistribution/components/list/CustomerDistributionSlot.vue';
import CustomerDistributionEmptySlot from '@/features/CustomerDistribution/components/list/CustomerDistributionEmptySlot.vue';
import { fetchRuleList } from '@/features/CustomerDistribution/data';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerDistribution',
    setup(__props) {
        const state = reactive({
            data: [],
            hasError: false,
            loading: false,
        });
        onMounted(() => {
            window.scroll({
                top: 0,
            });
        });
        const fetchList = () => {
            state.loading = true;
            fetchRuleList()
                .then(data => {
                state.data = data;
            })
                .catch(() => {
                state.hasError = true;
            })
                .finally(() => {
                state.loading = false;
            });
        };
        fetchList();
        return (_ctx, _cache) => {
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createBlock(_component_base_card_v2, { class: "cd-list" }, {
                default: _withCtx(() => [
                    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('customer-distribution.list.title')), 1),
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('customer-distribution.list.description')), 1),
                    (!state.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data, (item) => {
                                return (_openBlock(), _createBlock(CustomerDistributionSlot, {
                                    key: item.id,
                                    "slot-model": item
                                }, null, 8, ["slot-model"]));
                            }), 128))
                        ]))
                        : (_openBlock(), _createBlock(CustomerDistributionEmptySlot, { key: 1 }))
                ]),
                _: 1
            }));
        };
    }
});
